import React from 'react';
import { AlertCircle } from 'lucide-react';
import { ICON_STROKE_WIDTH } from '../../constants';
import type { CriticalityBand, MatrixValidationError } from '../../types/escalationMatrix.types';
import { groupActivationErrors } from '../../utils/escalationMatrixValidation';

interface EscalationValidationSummaryProps {
  errors: MatrixValidationError[];
  title?: string;
}

function formatError(error: MatrixValidationError): string {
  const bandPrefix = error.criticalityBand ? `${error.criticalityBand}: ` : '';
  const levelPrefix = error.levelNumber ? `Level ${error.levelNumber} — ` : '';
  return `${bandPrefix}${levelPrefix}${error.message}`;
}

export default function EscalationValidationSummary({
  errors,
  title = 'Fix these issues before activation',
}: Readonly<EscalationValidationSummaryProps>) {
  if (!errors.length) {
    return null;
  }

  const { general, byBand } = groupActivationErrors(errors);

  return (
    <div
      className="esc-validation-panel"
      role="alert"
    >
      <div className="esc-validation-panel-header">
        <AlertCircle
          size={18}
          strokeWidth={ICON_STROKE_WIDTH}
        />
        <strong>{title}</strong>
      </div>
      <ul className="esc-validation-list">
        {general.map((error, index) => (
          <li key={`general-${index}`}>{formatError(error)}</li>
        ))}
        {(['Major', 'Minor'] as CriticalityBand[]).map(band =>
          byBand[band].map((error, index) => <li key={`${band}-${index}`}>{formatError(error)}</li>)
        )}
      </ul>
    </div>
  );
}
